module.exports = __webpack_public_path__ + "img/bg5.c6ea44eb.png";